import { useToast } from '@chakra-ui/react';
import { useState } from 'react';

import { Draft } from '../../components/RequestDrafts/types';
import { trpc } from '../../config/trpc';

/** Discard a draft with an optional reason. */
export const useDiscardDraft = (
  draft: Draft | undefined,
  onResolved: () => void,
): [(reason: string) => Promise<void>, boolean] => {
  const toast = useToast();
  const [isDiscarding, setIsDiscarding] = useState(false);
  const discardDraft = trpc.discardRequestDraft.useMutation();

  const discard = async (reason: string) => {
    if (!draft) return;
    setIsDiscarding(true);
    try {
      await discardDraft.mutateAsync({ id: draft.id, reason: reason || undefined });
      toast({ title: 'Draft discarded', status: 'success' });
      onResolved();
    } catch (error) {
      toast({ title: 'Error', description: error?.message, status: 'error' });
    } finally {
      setIsDiscarding(false);
    }
  };

  return [discard, isDiscarding];
};
